import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { ClaudeReducerHandlers, GeneralReducerHandlers } from './handlers';
import { GeneralActionTypes } from '../actions/types';

const claudeReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...ClaudeReducerHandlers.askClaude,
    ...ClaudeReducerHandlers.wrapWithTagsAndSave,
    ...ClaudeReducerHandlers.generateClaudeReplyWithTranscript,
  },
);

export default claudeReducer;
